import { render, staticRenderFns } from "./Continue.vue?vue&type=template&id=18ed500a&scoped=true"
import script from "./Continue.vue?vue&type=script&lang=js"
export * from "./Continue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ed500a",
  null
  
)

export default component.exports